<template>
	<div class="wrapper">
		<side-bar v-if="$store.state.authentication.mode != 'driver' ">
			<sidebar-link to="/dashboard" v-if="allow_user('sa')">
				<md-icon>dashboard</md-icon>
				<p>របាយការណ៏</p>
			</sidebar-link>
			<sidebar-link to="/new_package" v-if="allow_user('sa|ca')">
				<md-icon>add_circle_outline</md-icon>
				<p>បញ្ចូលកញ្ចប់ឥវ៉ាន់ថ្មី</p>
			</sidebar-link>
			<sidebar-link to="/packages" v-if="allow_user('sa|ca|da')">
				<md-icon>card_giftcard</md-icon>
				<p>កញ្ចប់ឥវ៉ាន់</p>
			</sidebar-link>
			<!-- <sidebar-link to="/error_packages" v-if="allow_user('sa|ca')">
				<md-icon>error</md-icon>
				<p>កញ្ចប់ឥវ៉ាន់មានបញ្ហា</p>
			</sidebar-link> -->
			<sidebar-link to="/booking" v-if="allow_user('sa|ad|da|ca')">
				<md-icon>event</md-icon>
				<p>កក់យកកញ្ចប់ឥវ៉ាន់</p>
			</sidebar-link>
			<sidebar-link to="/payments" v-if="allow_user('sa|ad|ca|sl|da')">
				<md-icon>paid</md-icon>
				<p>ការទូទាត់ប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/accountant_payments" v-if="allow_user('ac')">
				<md-icon>paid</md-icon>
				<p>ការទូទាត់ប្រាក់គណនេយ្យ</p>
			</sidebar-link>
			<sidebar-link to="/transactions" v-if="allow_user('sa|ac')">
				<md-icon>history</md-icon>
				<p>ប្រវត្តិប្រតិបត្តិការ</p>
			</sidebar-link>
			<sidebar-link to="/clients" v-if="allow_user('sa|ca')">
				<md-icon>groups</md-icon>
				<p>អតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/referral" v-if="allow_user('sa')">
				<md-icon>diversity_3</md-icon>
				<p>អ្នកទីផ្សារ</p>
			</sidebar-link>
			<sidebar-link to="/drivers" v-if="allow_user('sa|ad|da')">
				<md-icon>two_wheeler</md-icon>
				<p>អ្នកដឹកជញ្ជូន</p>
			</sidebar-link>
			<sidebar-link to="/zones" v-if="allow_user('sa|ad')">
				<md-icon>map</md-icon>
				<p>តំបន់ដឹកជញ្ជូន</p>
			</sidebar-link>
			<sidebar-link to="/accountants" v-if="allow_user('sa')">
				<md-icon>diversity_1</md-icon>
				<p>គ្រប់គ្រងអ្នកគណនេយ្យ</p>
			</sidebar-link>
			<sidebar-link to="/notifications" v-if="allow_user('sa')">
				<md-icon>notifications</md-icon>
				<p>គ្រប់គ្រងសារជូនដំណឹង</p>
			</sidebar-link>
			<sidebar-link to="/settings" v-if="allow_user('sa')">
				<md-icon>settings</md-icon>
				<p>ការកំណត់ប្រព័ន្ធ</p>
			</sidebar-link>
			<sidebar-link to="/administrators" v-if="allow_user('sa')">
				<md-icon>supervised_user_circle</md-icon>
				<p>គ្រប់គ្រងគណនី</p>
			</sidebar-link>
		</side-bar>

		<side-bar v-if="$store.state.authentication.mode == 'driver' ">
			<sidebar-link to="/driver_packages">
				<md-icon>card_giftcard</md-icon>
				<p>កញ្ចប់ឥវ៉ាន់</p>
			</sidebar-link>
		</side-bar>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue